import { Component, type ReactNode } from "react";

/**
 * Упавший экран — запасной вид вместо белой страницы: меню кабинета вокруг
 * остаётся рабочим, кнопка перерисовывает экран, «Обновить» — страницу.
 * Сама ошибка уходит в журнал через `onCaughtError` корня (`main.tsx`),
 * здесь её второй раз не пишем. Смена адреса сбрасывает упавшее состояние.
 */
type Props = { children: ReactNode; resetKey?: string };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidUpdate(prev: Props): void {
    if (this.state.error && prev.resetKey !== this.props.resetKey) this.setState({ error: null });
  }

  render(): ReactNode {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div className="m-6 max-w-xl rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-900">
        <div className="font-medium">Экран упал</div>
        <div className="mt-1 break-words text-red-800">{error.message || error.name}</div>
        <div className="mt-1 text-xs text-red-700">Ошибка уже записана — её разберут.</div>
        <div className="mt-3 flex gap-2">
          <button
            type="button"
            className="rounded border border-red-300 bg-white px-3 py-1 hover:bg-red-100"
            onClick={() => this.setState({ error: null })}
          >
            Попробовать ещё раз
          </button>
          <button
            type="button"
            className="rounded border border-red-300 bg-white px-3 py-1 hover:bg-red-100"
            onClick={() => location.reload()}
          >
            Обновить страницу
          </button>
        </div>
      </div>
    );
  }
}
